import React, { Fragment, useState, useEffect } from 'react';
import propTypes from 'prop-types';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import Questions from 'components/installation/dynamicForm/questions';
import localization from 'assets/localization/localization';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';

const Troubleshoot = ({
  getTsQuestionnaire,
  postTsQuestionnaire,
  getFormDropdowns,
  formDropdowns,
  questionnaireList,
  questionnaireSaveRes,
  documentUploadUrl,
  match,
  history,
}) => {
  const [checkListData, setCheckListData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [complainId, setComplainId] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [materialList, setMaterialList] = useState(null);
  const [selectedMaterial, setSelectedMaterial] = useState('');
  const [allQuestions, setallQuestions] = useState([]);
  const [isFiled, setIsFiled] = useState(false);

  const handleIsSuccess = () => {
    setIsSuccess(false);
    history.push(`/dashboard/view-complain/${complainId}`);
  };

  const handleSubmit = async () => {
    const data = {
      material_id: selectedMaterial,
      complaint_id: complainId,
      checklist_answers: allQuestions,
    };
    if (allQuestions.length === checkListData[0].questions.length) {
      setIsFiled(true);
      setIsLoading(true);
      const res = await postTsQuestionnaire(data);
      setIsLoading(false);
      if (res) {
        setIsSuccess(true);
      }
    } else {
      setIsFiled(false);
    }
  };

  // useEffect(() => {
  //   if (questionnaireSaveRes !== null) {
  //     setIsSuccess(true);
  //   }
  // }, [questionnaireSaveRes]);

  const headerBtns = () => {
    return (
      <Fragment>
        {questionnaireList !== null && questionnaireList !== undefined && (
          <Button onClick={handleSubmit} className="btn btn-primary">
            {localization.submitDtl}
            <img src={Images?.ArrowRight} alt="" />
          </Button>
        )}
      </Fragment>
    );
  };

  useEffect(() => {
    setComplainId(match.params.id);
  }, [match]);

  useEffect(() => {
    if (formDropdowns !== null) {
      setMaterialList(formDropdowns.product || []);
    } else setMaterialList([]);
  }, [formDropdowns]);

  useEffect(() => {
    if (questionnaireList !== null && questionnaireList !== undefined) {
      setCheckListData([questionnaireList.materials]);
    } else setCheckListData([]);
  }, [questionnaireList]);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getFormDropdowns(match.params.id);
      setIsLoading(false);
    })();
  }, [getFormDropdowns]);

  const handleTruobleshoot = async () => {
    setIsLoading(true);
    await getTsQuestionnaire(selectedMaterial);
    setIsLoading(false);
  };

  const successIconBox = (text) => {
    return (
      <div className="text-center">
        <div className="success">
          <img src={Images?.tick} alt="" />
        </div>
        <h5>{localization.troubleshootSucess}</h5>
        <Button onClick={handleIsSuccess} className="btn btn-primary">
          {localization.viewComplain} <img src={Images?.ArrowRight} alt="" />
        </Button>
      </div>
    );
  };

  const handleQuestion = (val) => {
    if (val !== undefined && val !== null) {
      if (allQuestions && allQuestions.length === 0) {
        allQuestions.push(val);
        setallQuestions([...allQuestions]);
      } else {
        const isThere = allQuestions.findIndex((obj) => obj.id === val.id);
        if (isThere === -1) {
          allQuestions.push(val);
          setallQuestions([...allQuestions]);
        } else {
          allQuestions.splice(isThere, 1);
          allQuestions.push(val);
          setallQuestions([...allQuestions]);
        }
      }
    }
  };

  return (
    <Fragment>
      <Layout
        title={localization.troubleshoot}
        isLoading={isLoading}
        isGoback
        Buttons={headerBtns}
      >
        <PanelCardWithHeading title={localization.selectMaterial}>
          <DropDownInput
            label={localization.selectMaterial}
            data={materialList}
            required
            isStarRequired={true}
            errorMsg={localization.requiredErrorMg}
            getIdValue={(val) => setSelectedMaterial(val.id)}
          />
          <div className="form-group full-width">
            <Button
              disabled={selectedMaterial === ''}
              onClick={handleTruobleshoot}
              className="btn btn-primary"
            >
              {localization.submit} <img src={Images?.ArrowRight} alt="" />
            </Button>
          </div>
        </PanelCardWithHeading>
        {materialList !== null && checkListData.length > 0 && (
          <Questions
            data={checkListData}
            handleValue={handleQuestion}
            documentUploadUrl={documentUploadUrl}
            className={isFiled}
          />
        )}
      </Layout>
      <ModalPop
        title={localization.success}
        show={isSuccess}
        handleModalHide={handleIsSuccess}
      >
        {successIconBox()}
      </ModalPop>
    </Fragment>
  );
};

Troubleshoot.propTypes = {
  fetchComplainList: propTypes.func,
};

export default Troubleshoot;
